module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/c7813971976f3caf3b79841b01934f98.png";